import type { SupportedLocale } from "@shared/i18n/types";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { Center } from "@chakra-ui/react";

import { ErrorPageConnector } from "@pages/error";
import { getMessagesByLocale } from "@shared/i18n";
import { LocalesProvider } from "@shared/i18n-react-intl";
import { DEFAULT_LOCALE } from "@shared/i18n/constants";
import { ThemeProvider } from "@shared/ui/theme";

type Options<R = unknown> = {
  error: R;
};

export const renderCrashApp = async <R,>({ error }: Options<R>) => {
  const rootElement = document.getElementById("root");

  if (rootElement === null) {
    throw new Error(
      "Cannot render app. Please check your entrypoint (index.html)",
    );
  }

  console.error(error);

  const appRoot = createRoot(rootElement);

  const handleReload = () => {
    window.location.reload();
  };

  appRoot.render(
    <StrictMode>
      <ThemeProvider>
        <LocalesProvider<SupportedLocale>
          defaultLocale={DEFAULT_LOCALE}
          messagesGetter={getMessagesByLocale}
          renderChildren={() => {
            return (
              <Center h="100dvh">
                <ErrorPageConnector error={error} reset={handleReload} />
              </Center>
            );
          }}
        />
      </ThemeProvider>
    </StrictMode>,
  );
};
